<ng-container *ngIf="displaySentooLoginScreen">
  <div class="container">
    <div class="panel">
      <ng-container  *ngIf="loginMethod === 'app'">
        <ab-landing [rendering]="rendering" (loginWithToken)="loginWithToken()"></ab-landing>
      </ng-container>
      <ng-container  *ngIf="loginMethod === 'token'" >
        <ab-token-form [rendering]="rendering" (loginWithApp)="loginWithApp()"></ab-token-form>
      </ng-container>

    </div>
    <div class="panel-footer">
      <p class="fs-16">Need help?
        <a href="https://arubabank.com/About-Us/Customer-Support/Contact-Center" target="_blank">Contact us <span
            class="icon-opentab"></span>
        </a>
      </p>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!displaySentooLoginScreen">
  <div class="row old-login">
    <div class="col-md-12 col-lg-7">
      <h1 class="flex-grow-1 label-login" *scText="items.pageTitle.fields.title"></h1>
      <ng-container *ngIf="userBlockedError">
        <div class="alert label-login alert-danger">
          {{ formFields.genericErrors.userBlocked.message }}
        </div>
      </ng-container>

      <ng-container *ngIf="invalidCredentialsError">
        <div class="alert label-login alert-danger">
          {{ formFields.genericErrors.userFailed.message }}
        </div>
      </ng-container>

      <ng-container *ngIf="invalidLoginMessage">
        <div class="alert label-login alert-danger">
          {{ invalidLoginMessage }}
        </div>
      </ng-container>

      <form [formGroup]="loginForm" (submit)="submitAction()" class="mt-3">
        <div class="row">
          <div class="col-sm-10">
            <div class="form-group label-login" [ngClass]="{ 'mb-2': items.loginTool }">
              <label class="login" for="safeName">
                {{ formFields.fields.username.label.value }}
              </label>
              <ng-template #tipContent>
                <div *scRichText="items.formerUserInfo.fields.description"></div>
              </ng-template>
              <i class="icon-info-circle tooltip-icon" tooltipClass="tooltip-html" [ngbTooltip]="tipContent"
                placement="bottom"></i>

              <input class="form-control" [placeholder]="formFields.fields.username.placeholder"
                formControlName="username" #usernameInput [maxlength]="formFields.genericErrors.length.parameter" />

              <span class="field-validation-error" *ngIf="username.errors?.required">{{
                formFields.genericErrors.usernameRequired.message }}</span>
            </div>

            <div class="list-numbered fixed-view mt-2 mb-4">
              <ul>
                <li>
                  <div>
                    <label class="login label-login" *scRichText="items.chooseDevice.fields.stepText"></label>
                    <div class="d-flex">
                      <button class="token-wrapper" type="button" [ngClass]="{
                          'token-background': otpType.value === 'mobilephoneValue'
                        }" (click)="changeToken('mobilephoneValue')">
                        <div class="image-text-token">
                          <div class="image-soft-token"></div>
                          <div class="font-weight-normal fs-16 pt-1" *scText="formFields.fields.app.label"></div>
                        </div>
                      </button>
                      <button class="token-wrapper" type="button" [ngClass]="{
                          'token-background': otpType.value === 'abopassValue'
                        }" (click)="changeToken('abopassValue')">
                        <div class="image-text-token">
                          <div class="image-hard-token"></div>
                          <div class="font-weight-normal fs-16 pt-1" *scText="formFields.fields.token.label"></div>
                        </div>
                      </button>
                    </div>
                  </div>
                </li>
                <ng-container *ngIf="otpType.value === 'mobilephoneValue'">
                  <div class="active-zone mt-3">
                    <div class="form-group label-login">
                      <label class="login mt-1" for="logincode" *scText="formFields.fields.logincode.label"></label>

                      <input class="form-control" [placeholder]="formFields.fields.logincode.placeholder"
                        formControlName="logincode" #passwordInput
                        [maxlength]="formFields.genericErrors.length.parameter" />
                      <span class="field-validation-error" *ngIf="logincode.errors?.required">{{
                        formFields.genericErrors.required.message }}</span>
                    </div>
                    <div class="order-steps-list">
                      <div class="font-weight-normal fs-16 mb-2" *scText="formFields.fields.app.helpText"></div>
                      <li *ngFor="let item of items.app.fields.items; let i = index">
                        <div>
                          <div class="circle steps">
                            <span *scText="item.fields.stepNumber"></span>
                          </div>
                        </div>
                        <div>
                          <span *scRichText="item.fields.stepText"></span>
                        </div>
                      </li>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="otpType.value === 'abopassValue'">
                  <div class="active-zone mt-3">
                    <div class="form-group label-login">
                      <label class="login mt-1" for="logincode" *scText="formFields.fields.logincode.label"></label>

                      <input class="form-control" [placeholder]="formFields.fields.logincode.placeholder"
                        formControlName="logincode" #passwordInput
                        [maxlength]="formFields.genericErrors.length.parameter" />
                      <span class="field-validation-error" *ngIf="logincode.errors?.required">{{
                        formFields.genericErrors.required.message }}</span>
                    </div>
                    <div class="order-steps-list">
                      <div class="font-weight-normal fs-16 mb-2" *scText="formFields.fields.token.helpText"></div>
                      <li *ngFor="
                          let item of items.token.fields.items;
                          let i = index
                        ">
                        <div>
                          <div class="circle steps">
                            <span *scText="item.fields.stepNumber"></span>
                          </div>
                        </div>
                        <div>
                          <span *scRichText="item.fields.stepText"></span>
                        </div>
                      </li>
                    </div>
                  </div>
                </ng-container>
              </ul>
            </div>

            <div class="form-group label-login">
              <ng-container>
                <button class="btn btn-primary btn-step" [disabled]="loginForm.invalid || isLoading" abButtonLoader
                  [ngClass]="{ 'btn-loader': isLoading }">
                  <span *scRichText="submitButtonText"></span>
                </button>
              </ng-container>

              <!-- <ab-loader></ab-loader> -->
            </div>
          </div>
        </div>
      </form>
      <div class="help-area label-login">
        <h1 *scText="items.help.fields.title"></h1>
        <div class="links-wrapper">
          <ng-container *ngIf="items.pageTitle && items.pageTitle.fields">
            <div class="fs-18" *scRichText="items.pageTitle.fields.description"></div>
          </ng-container>
          <ng-container *ngIf="items.loginTool && items.loginTool.fields">
            <div class="fs-18 mb-20" *scRichText="items.loginTool.fields.text"></div>
          </ng-container>
          <ng-container *ngIf="formFields.fields.username.helpText">
            <div class="fs-18" *scRichText="formFields.fields.username.helpText"></div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>